import React, { useState, Fragment, useEffect } from "react";
import logo from "../public/Coin Basis Icon.svg"; // Update the path to the correct location
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import ProfileDropdown from "./ProfileDropdown";
import { VscAccount } from "react-icons/vsc";

const Navbar = () => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("session")) || null
  );

  useEffect(() => {
    checkSignIn();
  }, []);

  const checkSignIn = async () => {
    const session = await fetchAuthSession();
    setUser(session);
    localStorage.setItem("session", JSON.stringify(session));
  };

  const navigate = useNavigate();

  const handleSignOut = async () => {
    localStorage.setItem("session", null);
    await signOut();
    navigate("/");
    window.location.reload();
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <header className="header">
      <div className="logo-container">
        <a href="/" className="logo">
          <img alt="coinbasis-logo" src={logo} className="navbar-image1" />
          <span className="company-name">Coin Basis</span>
        </a>
      </div>
      <input className="menu-btn" type="checkbox" id="menu-btn" />
      <label className="menu-icon" htmlFor="menu-btn">
        <span className="navicon"></span>
      </label>

      <ul className="menu">
        <li>
          <a href="/" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">Home</span>
            </Fragment>
          </a>
        </li>
        <li>
          <a href="/about" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">About Us</span>
            </Fragment>
          </a>
        </li>
        <li>
          <a href="/howitworks" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">How It Works</span>
            </Fragment>
          </a>
        </li>
        <li>
          <a href="/estimator" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">Calculate My Taxes</span>
            </Fragment>
          </a>
        </li>
        <li>
          <a href="/portfolio" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">Portfolio</span>
            </Fragment>
          </a>
        </li>
        <li>
          <a href="/faq" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">FAQ</span>
            </Fragment>
          </a>
        </li>
        <li className="show-narrow">
          <a href="/estimator" className="thq-link thq-body-small">
            <Fragment>
              <span className="navbar-text">Get Started</span>
            </Fragment>
          </a>
        </li>
        <div className="navbar-buttons">
          <button
            className="faq-link thq-button-filled show-wide"
            onClick={() => handleNavigation("/estimator")}
          >
            <span href={"/estimator"} className="thq-body-medium">
              <Fragment>
                <span className="navbar-text">Get Started</span>
              </Fragment>
            </span>
          </button>
          {user?.tokens ? (
            <ProfileDropdown
              handleSignOut={handleSignOut}
              navigate={navigate}
              userName={user?.tokens?.idToken?.payload?.given_name}
              userEmail={user?.tokens?.idToken?.payload?.email}
            >
              <VscAccount size="2.5em" style={{ alignSelf: "center" }} />
            </ProfileDropdown>
          ) : (
            <button
              className="faq-link thq-button-outline show-wide"
              onClick={() => handleNavigation("/estimator")}
            >
              <a href="/estimator" className="thq-body-medium">
                <Fragment>
                  <span className="navbar-text">Sign in</span>
                </Fragment>
              </a>
            </button>
          )}
        </div>
      </ul>
    </header>
  );
};

export default Navbar;
